export default __webpack_public_path__ + "static/media/img51.f9aff5da.jpg";